import React, { useState, useEffect } from "react";
import { Chip } from "@mui/material";
import { Calendar, Whisper, Popover } from "rsuite";
import "rsuite/dist/rsuite-no-reset.min.css";
import { $crud } from "../utils/CrudFactory";

const CustomCalendarUI = () => {
  const [ordersData, setOrdersData] = useState({});
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  // Get today's date in 'YYYY-MM-DD' format
  const today = new Date().toISOString().split("T")[0]; // Correct full date format: 'YYYY-MM-DD'

  // Fetch orders data from API
  async function retrieveData() {
    try {
      const { data } = await $crud.retrieve("admin/orders/month", {
        year: currentYear,
        month: currentMonth,
      });
      return data;
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  }

  useEffect(() => {
    retrieveData().then((res) => {
      setOrdersData(res.ordersByDate || {});
    });
  }, [currentYear, currentMonth]);

  // Get the list of orders for a specific date
  function getTodoList(date) {
    const dateKey = date.toISOString().split("T")[0]; // Full date in 'YYYY-MM-DD'
    const orderInfo = ordersData[dateKey];

    if (orderInfo) {
      const list = [];
      if (orderInfo.regularOrders > 0) {
        list.push({
          title: `${orderInfo.regularOrders} Regular Orders`,
          bgcolor: "rgba(233, 159, 95, 1)",
          color: "black",
        });
      }
      if (orderInfo.vipOrders > 0) {
        list.push({
          title: `${orderInfo.vipOrders} VIP Orders`,
          color: "black",
          bgcolor: "rgba(104, 193, 153, 1)",
        });
      }
      return list;
    }
    return [];
  }

  // Render cell content for each date
  function renderCell(date) {
    const list = getTodoList(date);
    const displayList = list.filter((item, index) => index < 2); // Show up to 2 items

    if (list.length) {
      const moreCount = list.length - displayList.length;
      const moreItem = (
        <li key="more-item">
          <Whisper
            placement="top"
            trigger="click"
            speaker={
              <Popover>
                {list.map((item, index) => (
                  <p key={index}>{item.title}</p>
                ))}
              </Popover>
            }
          >
            <a>{moreCount} more</a>
          </Whisper>
        </li>
      );

      return (
        <div>
          {displayList.map((item, index) => (
            <Chip
              key={index}
              sx={{
                width: "144px",
                color: item.color,
                background: item.bgcolor,
                borderRadius: "4px",
                marginBottom: "2px",
              }}
              label={item.title}
            />
          ))}
          {list.length > 2 && moreItem}
        </div>
      );
    }

    return null;
  }

  // Custom cell styling based on the date
  function cellClassName(date) {
    const dateKey = date.toISOString().split("T")[0]; // Format date as 'YYYY-MM-DD'

    // Apply custom class if the date is today's date (exact match)
    if (dateKey === today) {
      return "current-date-cell";
    }
    return ""; // No custom class for other dates
  }

  // Handle month change
  const handleMonthChange = (nextDate) => {
    setCurrentMonth(nextDate.getMonth() + 1);
    setCurrentYear(nextDate.getFullYear());
  };

  return (
    <Calendar
      bordered
      renderCell={renderCell}
      cellClassName={cellClassName} // Apply custom class to cells
      format={{ weekday: "long" }} // Full weekday names
      onMonthChange={handleMonthChange}
    />
  );
};

export default CustomCalendarUI;
